import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import ResourceManager from '@/Management/ResourceManager';
import * as DateHelper from '@/Utility/DateHelper';
import Utilities from '@/Utility/Utilities';
import TypeConverter from '@/Utility/TypeConverter';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import Label from '@/Controls/Label';
import DateTimeLabelViewModel from '@/ViewModels/Controls/DateTimeLabelViewModel';
import DateTimeLabel from '@/Controls/DateTimeLabel';

export default class LabelFactory extends ControlFactory {

    private jQueryControl: JQuery;
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');
    protected Label = ComponentManager.getControl<typeof Label>('Label');
    private DateTimeLabelViewModel = ComponentManager.getViewModel<typeof DateTimeLabelViewModel>('DateTimeLabelViewModel');
    private DateTimeLabel = ComponentManager.getControl<typeof DateTimeLabel>('DateTimeLabel');

    public isFocusable: any;

    /**
     * @override
     */
    public viewModel: LabelViewModel | DateTimeLabelViewModel;

    public constructor(params: any) {
        super(params);
        this.isFocusable = false;
    }

    /**
     * @override
     */
    control: Label | DateTimeLabel;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        if (this.detailViewItem.viewModel != null) {
            this.viewModel = this.detailViewItem.viewModel as LabelViewModel;
            this.control = new this.Label(this.viewModel);
        } else {
            let value = this.context.genericObject.getValue(this.detailViewItem.name);

            if (DateHelper.isDotNetDatetimeString(value)) {
                this.viewModel = new this.DateTimeLabelViewModel({
                    parentLocator: this.locator,
                    locator: this.detailViewItem.name,
                    isEnabled: this.isEnabled,
                    isSummaryViewMode: this.isSummaryViewMode,
                    isValid: this.isValid,
                    invalidationText: this.invalidationText,
                    value: this.context.genericObject.getObservable(this.detailViewItem.name)
                });

                this.control = new this.DateTimeLabel(this.viewModel);
            } else {
                let erg = this.detailViewItem.unitErgName;
                let unitErgNameValue = null;
                if (!Utilities.isNullOrUndefinedOrBlank(erg)) {
                    let result = ResourceManager.getInstance().get(erg);
                    unitErgNameValue = result != null ? result : erg;
                }

                this.viewModel = new this.LabelViewModel({
                    parentLocator: this.locator,
                    locator: this.detailViewItem.name,
                    tooltip: new this.LabelViewModel({
                        ergName: this.detailViewItem.tooltip
                    }),
                    isEnabled: this.isEnabled,
                    isSummaryViewMode: this.isSummaryViewMode,
                    isValid: this.isValid,
                    invalidationText: this.invalidationText,
                    placeholder: '-',
                    caption: this.context.genericObject.getComputed(this.detailViewItem.name, {
                        read: (genericObservable: KnockoutObservable<any>): string => {
                            let val = genericObservable();
                            if (val === null || val === undefined) return "";
                            if (typeof val == "object") {
                                val = val.toString();
                            } else if (typeof val == "number") {
                                if (TypeConverter.typeIsNonFloatingNumber(this.detailViewItem.dotNetTypeName))
                                    val = Utilities.toLocaleNumber(val, 0);
                                else
                                    val = Utilities.toLocaleNumber(val);
                            } else if (typeof val != "string") {
                                val = "" + val;
                            }

                            let unit = this.detailViewItem.unitErgName;
                            if (unitErgNameValue != null && unitErgNameValue != "") {
                                val += ' ' + unitErgNameValue;
                            }

                            return val;
                        }
                    })
                });

                this.control = new this.Label(this.viewModel);
            }
        }

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.registerDefaultValidation([this.detailViewItem.name]);

        return this.jQueryControl;
    }

}

ComponentManager.setFactory('Label', LabelFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');